import { IWizardExecuteAllModel } from "../../../../components/Wizard";
import { IParticipantEmailDataModel } from "../ParticipantEmail";
import { ISendEmailDataModel } from "./";

export class SendEmailExecuteModel<T extends ISendEmailDataModel | IParticipantEmailDataModel> implements IWizardExecuteAllModel {

    public ids: number[];
    public formDataModel: T;

    public jsonIgnoreFields: string[] | null;

    constructor(idArray: number[], formData: T) {

        this.ids = idArray;
        this.formDataModel = formData;

        this.jsonIgnoreFields = [
            nameof<SendEmailExecuteModel<ISendEmailDataModel>>((m) => m.formDataModel.Attachments),
            nameof<SendEmailExecuteModel<ISendEmailDataModel>>((m) => m.formDataModel.EmailToItems),
            nameof<SendEmailExecuteModel<ISendEmailDataModel>>((m) => m.formDataModel.EmailFromItem),
            nameof<SendEmailExecuteModel<ISendEmailDataModel>>((m) => m.formDataModel.EmailCCAddressItems),
            nameof<SendEmailExecuteModel<ISendEmailDataModel>>((m) => m.formDataModel.EmailBCCAddressItems),
            nameof<SendEmailExecuteModel<ISendEmailDataModel>>((m) => m.formDataModel.UnlayerTemplate),
            nameof<SendEmailExecuteModel<ISendEmailDataModel>>((m) => m.formDataModel.Preview),
        ];
    }

    public jsonReplacer = (name: string, value: any) => {

        // For some reason, StarRez wants this particular property as a JSON String
        if (this.jsonIgnoreFields?.indexOf(name) !== -1) {
            value = undefined;
        }

        return value;
    }
}
